import { createReducer, on, Action, createFeatureSelector } from '@ngrx/store';
import * as FreezeBlockActions from './freeze-block.actions';

export const freezeBlockFeatureKey = 'freezeBlock';

export interface State {
  blockedEdition: boolean;
  userHasWriteAccessPermission: boolean;
  newsletterContentBlocksHidden:  string[]
}

export const initialState: State = {
  blockedEdition: null,
  userHasWriteAccessPermission: null,
  newsletterContentBlocksHidden: []
};

const freezeBlockReducer = createReducer(
  initialState,
  on(FreezeBlockActions.setFreezeBlocked, (state, { blocked }) => ({
    ...state,
    blockedEdition: blocked
  })),
  on(FreezeBlockActions.setUserHasWriteAccessPermission, (state, { userHasWriteAccessPermission }) => ({
    ...state,
    userHasWriteAccessPermission
  })),
  on(FreezeBlockActions.setHiddenContentBlocks, (state, { newsletterContentBlocksHidden }) => ({
    ...state,
    newsletterContentBlocksHidden
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return freezeBlockReducer(state, action);
}

export const selectFreezeBlockState = createFeatureSelector<State>(freezeBlockFeatureKey);
export const getBlockedEdition = (state: State) => state.blockedEdition;
export const getUserHasWriteAccessPermission = (state: State) => state.userHasWriteAccessPermission;
export const getNewsletterContentBlocksHidden = (state: State) => state.newsletterContentBlocksHidden;

